import axiosClient from '../axiosClient';

const notificationAPI = {
    async getList(params) {
        const url = `/notification_history`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getNotificationAPI(id, params) {
        const url = `/notification_history/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async update(id, data) {
        const url = `/notification_history/${id}`;
        const resp = await axiosClient.put(url, data);
        return resp;
    },
    async seenAll() {
        const url = `/notification_history/seen_all`;
        const resp = await axiosClient.get(url);
        return resp;
    },
    async getPostDetailAPI(id, params) {
        const url = `/post/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getPostAPI(params) {
        const url = `/post`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getPolicyPostListAPI(params) {
        const url = `/category_post`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default notificationAPI;
